import {
    Popper,
    Grow,
    Paper,
    MenuList,
    MenuItem,
} from '@material-ui/core';
import Box from '@mui/material/Box';
import { useContext } from 'react';
import { AdminContext } from '../../context/AdminContext/AdminContext';
import { startLogout } from '../../actions/auth';
import { useHistory} from 'react-router-dom';
import CheckPermission from '../../helpers/Administradores/Permissions';


const PopperHeader = ({ open, anchorRef,setOpen}: any) => {

    const { adminDispatch } = useContext(AdminContext);
    const history = useHistory();

    return (
        <Box zIndex="tooltip">
            <Popper data-testid="PopperMenu" open={open} anchorEl={anchorRef.current} transition disablePortal placement='bottom-end'>
                {({ TransitionProps, placement }) => (
                    <Grow
                        {...TransitionProps}
                        style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
                    >
                        <Paper>
                            <MenuList id="menu-list-grow">
                              {CheckPermission("Sidebar.MiEmpresa") && (
                                <MenuItem  onClick={() => {
                                        history.push("/miempresa");
                                        }}>
                                    Mi Compañía</MenuItem>
                                 )}
                                <MenuItem onClick={() => {
                                        history.push("/payment");
                                        }}>
                                    Facturación y Pagos</MenuItem>
                                <MenuItem onClick={()=>startLogout(adminDispatch!)}>Cerrar Sesión</MenuItem>

                            </MenuList>
                        </Paper>
                    </Grow>
                )}
            </Popper>
        </Box>
    );
};

export default PopperHeader;
